import type { FileRejection } from 'react-dropzone'

import FileDropzone, {
  type TFileDropzoneFile,
  type TFileDropzoneInputFile,
} from '../../FileDropzone'

type Props = {
  files: TFileDropzoneFile[]
  addFiles: (files: TFileDropzoneInputFile[]) => void
  removeFile: (index: number) => void
}

const NewTicketFilesForm = (props: Props) => {
  const { addFiles, removeFile, files } = props

  return (
    <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row sm:space-x-6 py-8">
      <div className="flex-[2]">
        <h3 className="text-xl font-semibold tracking-tight">
          File upload (optional)
        </h3>
        <p className="text-gray-700 text-sm mt-1">
          Uploading multiple files is supported, however ZIP folders are not.
          Maximum upload size is 25MB.
        </p>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg shadow-xs px-6 py-5 flex-[3] space-y-4">
        <FileDropzone
          files={files}
          onAccepted={(acceptedFiles) => addFiles(acceptedFiles)}
          onRejected={(fileRejections: FileRejection[]) =>
            addFiles(
              fileRejections.map(({ file, errors }) => {
                return Object.assign(file, {
                  rejectReason: errors[0]?.message,
                }) as TFileDropzoneInputFile
              }),
            )
          }
          onRemoveFile={(index) => removeFile(index)}
        />
      </div>
    </div>
  )
}

export default NewTicketFilesForm
